
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthH34xQxvlHTgWV1x8QwAqD4lI3vlQV6yy_MQ3fr43nT8Meta } from "/harness/apps/sf/app/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93pI0HmOVhO2vqyEXPdvSx_45tmCNy8J2lqD3Zd5Z9_DHjUMeta } from "/harness/apps/sf/app/pages/[...slug].vue?macro=true";
import { default as indexl_aucp1xIASSC_45uifInNjw8iqTdYsSWj_45UTZanYMjuEMeta } from "/harness/apps/sf/app/pages/[airport]/index.vue?macro=true";
import { default as _91operator_93WoCQs5fSMrG3geu3y3TdmEZRc5SCKIMaHkGHeNi6G2AMeta } from "/harness/apps/sf/app/pages/[airport]/b/[operator].vue?macro=true";
import { default as _91location_93RCBDBXEaNN0c_t4tUABxPaa4izdFIK9nyDwFIEUMubwMeta } from "/harness/apps/sf/app/pages/[airport]/l/[location].vue?macro=true";
import { default as _91transfer_93KBEeNMRX5oI1_45XjI8GZTuMIDvIBY97De9WXWrxT45IYMeta } from "/harness/apps/sf/app/pages/[airport]/t/[transfer].vue?macro=true";
import { default as component_45stub6mHxdPUx8G0CwmpyyXmm1pf1HKbFhODNpAqRbvvDSYUMeta } from "/harness/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.24_db0@0.3._3d7fa9b0102dbe17d9dcb9500aa26559/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6mHxdPUx8G0CwmpyyXmm1pf1HKbFhODNpAqRbvvDSYU } from "/harness/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.24_db0@0.3._3d7fa9b0102dbe17d9dcb9500aa26559/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/harness/apps/sf/app/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/harness/apps/sf/app/pages/[...slug].vue")
  },
  {
    name: "airport___en",
    path: "/:airport([A-Za-z]{3})",
    meta: indexl_aucp1xIASSC_45uifInNjw8iqTdYsSWj_45UTZanYMjuEMeta || {},
    component: () => import("/harness/apps/sf/app/pages/[airport]/index.vue")
  },
  {
    name: "airport-b-operator___en",
    path: "/:airport()/b/:operator()",
    component: () => import("/harness/apps/sf/app/pages/[airport]/b/[operator].vue")
  },
  {
    name: "airport-l-location___en",
    path: "/:airport([A-Za-z]{3})/l/:location",
    meta: _91location_93RCBDBXEaNN0c_t4tUABxPaa4izdFIK9nyDwFIEUMubwMeta || {},
    component: () => import("/harness/apps/sf/app/pages/[airport]/l/[location].vue")
  },
  {
    name: "airport-t-transfer___en",
    path: "/:airport()/t/:transfer()",
    component: () => import("/harness/apps/sf/app/pages/[airport]/t/[transfer].vue")
  },
  {
    name: component_45stub6mHxdPUx8G0CwmpyyXmm1pf1HKbFhODNpAqRbvvDSYUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub6mHxdPUx8G0CwmpyyXmm1pf1HKbFhODNpAqRbvvDSYU
  }
]